 import { DirectiveOptions } from "vue";
import { DirectiveBinding } from "vue/types/options";

function setPosition(element: HTMLElement, binding: DirectiveBinding) {
    element.style.position = "fixed";
    const titleFlagTop = binding.value.height * 0.26;
    const titleFlagWidth = binding.value.width * 0.065;
    const titleFlagHeight = titleFlagWidth * 1.20;
    const titleFlagLeft = binding.value.width * 0.615;
    element.style.top = titleFlagTop + "px";
    element.style.left = titleFlagLeft + "px";
    element.style.width = titleFlagWidth + "px";
    element.style.height = titleFlagHeight + "px";
}

const titleFlag: DirectiveOptions = {
    inserted(el, binding) {
        setPosition(el, binding);
    },
    update(el, binding) {
        setPosition(el, binding);
    }
};

export default titleFlag;
